import {makeAutoObservable} from 'mobx';
import MicroreelsRepository from '../../../data/repositories/MicroreelsRepository';
import LoadingModule from '../../LoadingModule/LoadingModule';
import {toast} from 'react-toastify';
import {microreelsLibraryText} from '../microreelsLibraryText';
import {toastConfig} from '../../../uiToolkit/Toast/toastConfig';
import {getErrorFromCode} from '../../../data/errorCodes';

class MicroreelsLibraryStore {
  private microreelsRepo = new MicroreelsRepository();

  private isOpen = false;
  private isGradable = false;
  private loadingModule = new LoadingModule();
  private onFinishCallback?: () => void;

  constructor() {
    makeAutoObservable(this);
  }

  public get isLoading() {
    return this.loadingModule.isLoading;
  }

  public get showLibrary() {
    return this.isOpen;
  }

  public openLibrary(isGradable: boolean, onFinishCallback?: () => void) {
    this.isOpen = true;
    this.isGradable = isGradable;
    this.onFinishCallback = onFinishCallback;
  }

  public closeLibrary() {
    this.isOpen = false;
    this.onFinishCallback = undefined;
  }

  public async getMicroreelsLibrary(
    organizationId: string,
    page: number,
    pageSize: number,
    search?: string,
  ) {
    const result = await this.microreelsRepo.getMicroreelsLibrary(
      organizationId,
      page,
      pageSize,
      this.isGradable ? undefined : false,
      search,
    );
    if (result.success && result.data) {
      return result.data;
    }
    return {
      pagesCount: 0,
      data: [],
    };
  }

  public async copyMicroreelsToCourse(
    organizationId: string,
    courseId: string,
    folderId: string,
    microreelIds: string[],
  ) {
    if (!microreelIds.length) return;
    this.loadingModule.startLoading();
    const result = await this.microreelsRepo.copyMicroreelsToCourse(
      organizationId,
      courseId,
      folderId,
      microreelIds,
    );
    this.loadingModule.endLoading();
    if (result.success) {
      toast.success(
        microreelIds.length === 1
          ? microreelsLibraryText.reelCopied
          : microreelsLibraryText.reelsCopied,
        toastConfig,
      );
      if (this.onFinishCallback) {
        this.onFinishCallback();
        this.closeLibrary();
      }
    } else if (result.errors && result.errors.length) {
      toast.error(getErrorFromCode(result.errors[0]));
    }
  }
}

export default MicroreelsLibraryStore;
